var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAmplifier(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Amplifier"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Amplifier",
    clipPath: "url(#clip-Amplifier)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "amplifier-2",
    "data-name": "amplifier",
    transform: "translate(16 23.4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1578",
    "data-name": "Path 1578",
    d: "M81.6,443.2a15.19,15.19,0,0,1-15.2,15.2H49.6a15.19,15.19,0,0,1-15.2-15.2V425.6a15.19,15.19,0,0,1,15.2-15.2H66.4a15.19,15.19,0,0,1,15.2,15.2S81.6,443.2,81.6,443.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1579",
    "data-name": "Path 1579",
    d: "M445.6,443.2a15.19,15.19,0,0,1-15.2,15.2H413.6a15.19,15.19,0,0,1-15.2-15.2V425.6a15.19,15.19,0,0,1,15.2-15.2h16.8a15.19,15.19,0,0,1,15.2,15.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1580",
    "data-name": "Path 1580",
    d: "M416,112a15.19,15.19,0,0,1-15.2,15.2H79.2A15.19,15.19,0,0,1,64,112V36.8A15.19,15.19,0,0,1,79.2,21.6H400.8A15.19,15.19,0,0,1,416,36.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1581",
    "data-name": "Path 1581",
    d: "M480,386.4a31.238,31.238,0,0,1-31.2,31.2H31.2A31.238,31.238,0,0,1,0,386.4V70.4c0-17.6,14.4-24,31.2-24H448c17.6,0,31.2,6.4,31.2,24v316Z",
    fill: "#5b5e5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1582",
    "data-name": "Path 1582",
    d: "M480,396a31.238,31.238,0,0,1-31.2,31.2H31.2A31.238,31.238,0,0,1,0,396V87.2C0,70.4,14.4,56,31.2,56H448a31.238,31.238,0,0,1,31.2,31.2V396Z",
    fill: "#414442"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1583",
    "data-name": "Path 1583",
    d: "M449.6,383.2a26.976,26.976,0,0,1-27.2,27.2H56.8a26.976,26.976,0,0,1-27.2-27.2V117.6A26.976,26.976,0,0,1,56.8,90.4H422.4a26.976,26.976,0,0,1,27.2,27.2V383.2Z",
    fill: "#303331"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1584",
    "data-name": "Path 1584",
    d: "M449.6,374.4a26.976,26.976,0,0,1-27.2,27.2H56.8a26.976,26.976,0,0,1-27.2-27.2V108.8A26.976,26.976,0,0,1,56.8,81.6H422.4a26.976,26.976,0,0,1,27.2,27.2V374.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "SVGCleanerId_0",
    d: "M423.2,82.4H56.8a26.976,26.976,0,0,0-27.2,27.2v80h420v-80C449.6,94.4,437.6,82.4,423.2,82.4Z",
    fill: "#eaae1b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1585",
    "data-name": "Path 1585",
    d: "M423.2,88.8H56.8A26.976,26.976,0,0,0,29.6,116v80h420V116C449.6,100.8,437.6,88.8,423.2,88.8Z",
    fill: "#e8c51c"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_188",
    "data-name": "Group 188"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SVGCleanerId_0_1_",
    d: "M423.2,82.4H56.8a26.976,26.976,0,0,0-27.2,27.2v80h420v-80C449.6,94.4,437.6,82.4,423.2,82.4Z",
    fill: "#eaae1b"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_100",
    "data-name": "Rectangle 100",
    width: 72,
    height: 56,
    transform: "translate(187.2 133.6)",
    fill: "#a8750f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1586",
    "data-name": "Path 1586",
    d: "M259.2,130.4h0c1.6-2.4,2.4-5.6.8-8l-3.2-5.6c-1.6-2.4-4.8-4-7.2-3.2h0a5.917,5.917,0,0,0-3.2-7.2l-5.6-3.2a5.956,5.956,0,0,0-7.2.8h-.8a6.969,6.969,0,0,0-6.4-4.8H220a6.969,6.969,0,0,0-6.4,4.8h-.8c-1.6-2.4-4.8-2.4-8-.8l-4.8,3.2c-2.4,1.6-4,4-3.2,7.2h0a5.917,5.917,0,0,0-7.2,3.2l-3.2,5.6a5.956,5.956,0,0,0,.8,7.2v.8a6.969,6.969,0,0,0-4.8,6.4v6.4a6.969,6.969,0,0,0,4.8,6.4v.8a5.956,5.956,0,0,0-.8,7.2l3.2,5.6c1.6,2.4,4.8,4,7.2,3.2h0a5.917,5.917,0,0,0,3.2,7.2l5.6,3.2c2.4,1.6,5.6.8,8-.8h.8a6.969,6.969,0,0,0,6.4,4.8h6.4a6.969,6.969,0,0,0,6.4-4.8h.8c1.6,2.4,4.8,2.4,7.2.8l5.6-3.2c2.4-1.6,4-4.8,3.2-7.2h0a5.917,5.917,0,0,0,7.2-3.2l3.2-5.6a5.956,5.956,0,0,0-.8-7.2v-.8a6.969,6.969,0,0,0,4.8-6.4v-6.4C264,133.6,262.4,131.2,259.2,130.4Z",
    fill: "#121c1b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1587",
    "data-name": "Path 1587",
    d: "M259.2,128h0c1.6-2.4,2.4-5.6.8-8l-3.2-5.6c-1.6-2.4-4.8-4-7.2-3.2h0a5.917,5.917,0,0,0-3.2-7.2l-5.6-3.2a5.956,5.956,0,0,0-7.2.8h-.8a6.969,6.969,0,0,0-6.4-4.8H220a6.969,6.969,0,0,0-6.4,4.8h-.8c-1.6-2.4-4.8-2.4-8-.8L200,104c-2.4,1.6-4,4.8-3.2,7.2h0a5.917,5.917,0,0,0-7.2,3.2l-3.2,5.6a5.956,5.956,0,0,0,.8,7.2v.8a6.969,6.969,0,0,0-4.8,6.4v6.4a6.969,6.969,0,0,0,4.8,6.4v.8a5.956,5.956,0,0,0-.8,7.2l3.2,5.6c1.6,2.4,4.8,4,7.2,3.2h0a5.917,5.917,0,0,0,3.2,7.2l5.6,3.2c2.4,1.6,5.6.8,8-.8h.8a6.969,6.969,0,0,0,6.4,4.8h6.4c3.2,0,5.6-1.6,6.4-4.8h.8a5.956,5.956,0,0,0,7.2.8l5.6-3.2c2.4-1.6,4-4.8,3.2-7.2h0a5.917,5.917,0,0,0,7.2-3.2l3.2-5.6a5.956,5.956,0,0,0-.8-7.2v-.8a6.969,6.969,0,0,0,4.8-6.4v-6.4C264,131.2,262.4,128.8,259.2,128Z",
    fill: "#5d6466"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1588",
    "data-name": "Path 1588",
    d: "M259.2,128h0c1.6-2.4,2.4-5.6.8-8l-3.2-5.6c-1.6-2.4-4.8-4-7.2-3.2h0a5.917,5.917,0,0,0-3.2-7.2l-5.6-3.2a5.956,5.956,0,0,0-7.2.8h-.8a6.969,6.969,0,0,0-6.4-4.8H220a6.969,6.969,0,0,0-6.4,4.8h-.8c-1.6-2.4-4.8-2.4-8-.8L200,104c-2.4,1.6-4,4.8-3.2,7.2h0L249.6,164h0a5.917,5.917,0,0,0,7.2-3.2l3.2-5.6a5.956,5.956,0,0,0-.8-7.2v-.8a6.969,6.969,0,0,0,4.8-6.4v-6.4C264,131.2,262.4,128.8,259.2,128Z",
    fill: "#4b5556"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1589",
    "data-name": "Path 1589",
    d: "M223.2,115.2c12.8,0,22.4,9.6,23.2,22.4V136a24,24,0,0,0-48,0v1.6C200.8,124.8,211.2,115.2,223.2,115.2Z",
    fill: "#566366"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1590",
    "data-name": "Path 1590",
    d: "M223.2,113.6a24.068,24.068,0,0,0-24,24c0,8,4,24.8,9.6,37.6a11.371,11.371,0,0,0,4.8-1.6h.8a6.969,6.969,0,0,0,6.4,4.8h6.4c3.2,0,5.6-1.6,6.4-4.8h.8a6.763,6.763,0,0,0,4.8,1.6c5.6-12.8,9.6-29.6,9.6-37.6C247.2,124,236.8,113.6,223.2,113.6Z",
    fill: "#424b4c"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_85",
    "data-name": "Ellipse 85",
    cx: 24,
    cy: 24,
    r: 24,
    transform: "translate(199.2 113.6)",
    fill: "#121c1b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1591",
    "data-name": "Path 1591",
    d: "M206.4,153.6c-9.6-9.6-9.6-24,0-33.6s24-9.6,33.6,0",
    fill: "#283538"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1592",
    "data-name": "Path 1592",
    d: "M224.8,126.4a1.721,1.721,0,0,1-1.6,1.6h0a1.721,1.721,0,0,1-1.6-1.6v-4.8a1.721,1.721,0,0,1,1.6-1.6h0a1.721,1.721,0,0,1,1.6,1.6Z",
    fill: "#121c1b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1593",
    "data-name": "Path 1593",
    d: "M224.8,124a1.721,1.721,0,0,1-1.6,1.6h0a1.721,1.721,0,0,1-1.6-1.6v-4.8a1.721,1.721,0,0,1,1.6-1.6h0a1.721,1.721,0,0,1,1.6,1.6Z",
    fill: "#eaae1b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_101",
    "data-name": "Rectangle 101",
    width: 72,
    height: 56,
    transform: "translate(284.8 133.6)",
    fill: "#a8750f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1594",
    "data-name": "Path 1594",
    d: "M356.8,130.4h0c1.6-2.4,2.4-5.6.8-8l-3.2-5.6c-1.6-2.4-4.8-4-7.2-3.2h0a5.917,5.917,0,0,0-3.2-7.2l-5.6-3.2a5.956,5.956,0,0,0-7.2.8h-.8a6.969,6.969,0,0,0-6.4-4.8h-6.4a6.969,6.969,0,0,0-6.4,4.8h-.8c-1.6-2.4-4.8-2.4-8-.8l-5.6,3.2c-2.4,1.6-4,4-3.2,7.2h0a5.917,5.917,0,0,0-7.2,3.2l-3.2,5.6a5.956,5.956,0,0,0,.8,7.2v.8a6.969,6.969,0,0,0-4.8,6.4v6.4a6.969,6.969,0,0,0,4.8,6.4v.8a5.956,5.956,0,0,0-.8,7.2l3.2,5.6c1.6,2.4,4.8,4,7.2,3.2h0a5.917,5.917,0,0,0,3.2,7.2l5.6,3.2c2.4,1.6,5.6.8,8-.8h.8a6.969,6.969,0,0,0,6.4,4.8H324a6.969,6.969,0,0,0,6.4-4.8h.8c1.6,2.4,4.8,2.4,7.2.8l5.6-3.2c2.4-1.6,4-4.8,3.2-7.2h0a5.917,5.917,0,0,0,7.2-3.2l3.2-5.6a5.956,5.956,0,0,0-.8-7.2v-.8a6.969,6.969,0,0,0,4.8-6.4v-6.4A6.969,6.969,0,0,0,356.8,130.4Z",
    fill: "#121c1b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1595",
    "data-name": "Path 1595",
    d: "M356.8,128h0c1.6-2.4,2.4-5.6.8-8l-3.2-5.6c-1.6-2.4-4.8-4-7.2-3.2h0A5.917,5.917,0,0,0,344,104l-5.6-3.2a5.956,5.956,0,0,0-7.2.8h-.8a6.969,6.969,0,0,0-6.4-4.8h-6.4a6.969,6.969,0,0,0-6.4,4.8h-.8c-1.6-2.4-4.8-2.4-8-.8l-4.8,3.2c-2.4,1.6-4,4.8-3.2,7.2h0a5.917,5.917,0,0,0-7.2,3.2L284,120a5.956,5.956,0,0,0,.8,7.2v.8a6.969,6.969,0,0,0-4.8,6.4v6.4a6.969,6.969,0,0,0,4.8,6.4v.8a5.956,5.956,0,0,0-.8,7.2l3.2,5.6c1.6,2.4,4.8,4,7.2,3.2h0a5.917,5.917,0,0,0,3.2,7.2l5.6,3.2c2.4,1.6,5.6.8,8-.8h.8a6.969,6.969,0,0,0,6.4,4.8h6.4c3.2,0,5.6-1.6,6.4-4.8h.8a5.956,5.956,0,0,0,7.2.8l5.6-3.2c2.4-1.6,4-4.8,3.2-7.2h0a5.917,5.917,0,0,0,7.2-3.2l3.2-5.6a5.956,5.956,0,0,0-.8-7.2v-.8a6.969,6.969,0,0,0,4.8-6.4v-6.4A9.146,9.146,0,0,0,356.8,128Z",
    fill: "#5d6466"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1596",
    "data-name": "Path 1596",
    d: "M356.8,128h0c1.6-2.4,2.4-5.6.8-8l-3.2-5.6c-1.6-2.4-4.8-4-7.2-3.2h0A5.917,5.917,0,0,0,344,104l-5.6-3.2a5.956,5.956,0,0,0-7.2.8h-.8a6.969,6.969,0,0,0-6.4-4.8h-6.4a6.969,6.969,0,0,0-6.4,4.8h-.8c-1.6-2.4-4.8-2.4-8-.8l-4.8,3.2c-2.4,1.6-4,4.8-3.2,7.2h0L347.2,164h0a5.917,5.917,0,0,0,7.2-3.2l3.2-5.6a5.956,5.956,0,0,0-.8-7.2v-.8a6.969,6.969,0,0,0,4.8-6.4v-6.4A6.969,6.969,0,0,0,356.8,128Z",
    fill: "#4b5556"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1597",
    "data-name": "Path 1597",
    d: "M320.8,115.2c12.8,0,22.4,9.6,23.2,22.4V136a24,24,0,1,0-48,0v1.6C297.6,124.8,308,115.2,320.8,115.2Z",
    fill: "#566366"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1598",
    "data-name": "Path 1598",
    d: "M320.8,113.6a24.068,24.068,0,0,0-24,24c0,8,4,24.8,9.6,37.6a11.37,11.37,0,0,0,4.8-1.6h.8a6.969,6.969,0,0,0,6.4,4.8h6.4c3.2,0,5.6-1.6,6.4-4.8h.8a6.763,6.763,0,0,0,4.8,1.6c5.6-12.8,9.6-29.6,9.6-37.6C344,124,333.6,113.6,320.8,113.6Z",
    fill: "#424b4c"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_86",
    "data-name": "Ellipse 86",
    cx: 24,
    cy: 24,
    r: 24,
    transform: "translate(296.8 113.6)",
    fill: "#121c1b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1599",
    "data-name": "Path 1599",
    d: "M304,153.6c-9.6-9.6-9.6-24,0-33.6s24-9.6,33.6,0",
    fill: "#283538"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1600",
    "data-name": "Path 1600",
    d: "M322.4,126.4a1.721,1.721,0,0,1-1.6,1.6h0a1.721,1.721,0,0,1-1.6-1.6v-4.8a1.721,1.721,0,0,1,1.6-1.6h0a1.721,1.721,0,0,1,1.6,1.6Z",
    fill: "#121c1b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1601",
    "data-name": "Path 1601",
    d: "M322.4,124a1.721,1.721,0,0,1-1.6,1.6h0a1.721,1.721,0,0,1-1.6-1.6v-4.8a1.721,1.721,0,0,1,1.6-1.6h0a1.721,1.721,0,0,1,1.6,1.6Z",
    fill: "#eaae1b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1602",
    "data-name": "Path 1602",
    d: "M86.4,172a6.31,6.31,0,0,1-6.4,6.4H55.2a6.31,6.31,0,0,1-6.4-6.4V130.4a6.31,6.31,0,0,1,6.4-6.4H80.8a6.31,6.31,0,0,1,6.4,6.4V172Z",
    fill: "#e8c51c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1603",
    "data-name": "Path 1603",
    d: "M86.4,168.8a6.31,6.31,0,0,1-6.4,6.4H55.2a6.31,6.31,0,0,1-6.4-6.4V127.2a6.31,6.31,0,0,1,6.4-6.4H80.8a6.31,6.31,0,0,1,6.4,6.4v41.6Z",
    fill: "#a8750f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1604",
    "data-name": "Path 1604",
    d: "M86.4,160.8a6.31,6.31,0,0,1-6.4,6.4H55.2a6.31,6.31,0,0,1-6.4-6.4V119.2a6.31,6.31,0,0,1,6.4-6.4H80.8a6.31,6.31,0,0,1,6.4,6.4v41.6Z",
    fill: "#e21e36"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1605",
    "data-name": "Path 1605",
    d: "M80.8,112.8a6.31,6.31,0,0,1,6.4,6.4v41.6a6.31,6.31,0,0,1-6.4,6.4H55.2a6.31,6.31,0,0,1-6.4-6.4",
    fill: "#ba0d1a"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_87",
    "data-name": "Ellipse 87",
    cx: 16.8,
    cy: 16.8,
    r: 16.8,
    transform: "translate(110.4 120.8)",
    fill: "#4f3715"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1606",
    "data-name": "Path 1606",
    d: "M127.2,131.2a17.048,17.048,0,0,0-16,12c2.4,6.4,8,12,16,12a17.048,17.048,0,0,0,16-12A17.048,17.048,0,0,0,127.2,131.2Z",
    fill: "#6d4f1b"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_189",
    "data-name": "Group 189"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1607",
    "data-name": "Path 1607",
    d: "M36.8,91.2H443.2a26.7,26.7,0,0,0-20-9.6H56.8C48.8,82.4,41.6,85.6,36.8,91.2Z",
    fill: "#a8750f"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_88",
    "data-name": "Ellipse 88",
    cx: 4,
    cy: 4,
    r: 4,
    transform: "translate(376 110.4)",
    fill: "#a8750f"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_89",
    "data-name": "Ellipse 89",
    cx: 4,
    cy: 4,
    r: 4,
    transform: "translate(392 110.4)",
    fill: "#a8750f"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_90",
    "data-name": "Ellipse 90",
    cx: 4,
    cy: 4,
    r: 4,
    transform: "translate(407.2 110.4)",
    fill: "#a8750f"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_91",
    "data-name": "Ellipse 91",
    cx: 4,
    cy: 4,
    r: 4,
    transform: "translate(423.2 110.4)",
    fill: "#a8750f"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_92",
    "data-name": "Ellipse 92",
    cx: 4,
    cy: 4,
    r: 4,
    transform: "translate(376 125.6)",
    fill: "#a8750f"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_93",
    "data-name": "Ellipse 93",
    cx: 4,
    cy: 4,
    r: 4,
    transform: "translate(392 125.6)",
    fill: "#a8750f"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_94",
    "data-name": "Ellipse 94",
    cx: 4,
    cy: 4,
    r: 4,
    transform: "translate(407.2 125.6)",
    fill: "#a8750f"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_95",
    "data-name": "Ellipse 95",
    cx: 4,
    cy: 4,
    r: 4,
    transform: "translate(423.2 125.6)",
    fill: "#a8750f"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_96",
    "data-name": "Ellipse 96",
    cx: 4,
    cy: 4,
    r: 4,
    transform: "translate(376 140.8)",
    fill: "#a8750f"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_97",
    "data-name": "Ellipse 97",
    cx: 4,
    cy: 4,
    r: 4,
    transform: "translate(392 140.8)",
    fill: "#a8750f"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_98",
    "data-name": "Ellipse 98",
    cx: 4,
    cy: 4,
    r: 4,
    transform: "translate(407.2 140.8)",
    fill: "#a8750f"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_99",
    "data-name": "Ellipse 99",
    cx: 4,
    cy: 4,
    r: 4,
    transform: "translate(423.2 140.8)",
    fill: "#a8750f"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_100",
    "data-name": "Ellipse 100",
    cx: 4,
    cy: 4,
    r: 4,
    transform: "translate(376 156)",
    fill: "#a8750f"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_101",
    "data-name": "Ellipse 101",
    cx: 4,
    cy: 4,
    r: 4,
    transform: "translate(392 156)",
    fill: "#a8750f"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_102",
    "data-name": "Ellipse 102",
    cx: 4,
    cy: 4,
    r: 4,
    transform: "translate(407.2 156)",
    fill: "#a8750f"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_103",
    "data-name": "Ellipse 103",
    cx: 4,
    cy: 4,
    r: 4,
    transform: "translate(423.2 156)",
    fill: "#a8750f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_190",
    "data-name": "Group 190"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1608",
    "data-name": "Path 1608",
    d: "M0,396a31.238,31.238,0,0,0,31.2,31.2h4V394.4H0Z",
    fill: "#101110"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1609",
    "data-name": "Path 1609",
    d: "M480,396a31.238,31.238,0,0,1-31.2,31.2h-4V394.4H480Z",
    fill: "#101110"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmplifier);
export default __webpack_public_path__ + "static/media/Amplifier.748059c3681ba25cfaa8e4d93130c62d.svg";
export { ForwardRef as ReactComponent };